import React from 'react';

import PlayerSliderControl from '../sliderControl/SliderControl';
import { getApp } from '../../App';
import style from './TerrainProfile.css';

function ClipPath({ refCallback }) {
  return (
    <svg className={style.pathSvg}>
      <clipPath id='altitudePath'>
        <path ref={refCallback} />
      </clipPath>
    </svg>
  );
}

class TerrainProfileCanvas extends React.Component {
  constructor(props) {
    super(props);

    this.setClipPathRef = el => {
      this.clipPath = el;
    };
    this.setFgCanvasRef = el => {
      this.fgCanvas = el;
    };
    this.setBgCanvasRef = el => {
      this.bgCanvas = el;
    };
  }

  componentDidMount() {
    const terrainProfile = getApp().terrainProfile;
    terrainProfile.onComponentMounted(this.bgCanvas, this.fgCanvas, this.clipPath);
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <div className={style.profileHolder}>
        <ClipPath refCallback={this.setClipPathRef} />
        <canvas className={style.profileCanvas} ref={this.setBgCanvasRef} />
        <canvas className={style.profileCanvas} ref={this.setFgCanvasRef} />
        <PlayerSliderControl />
      </div>
    );
  }
}

export default TerrainProfileCanvas;
